"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_1 = require("apollo-link");
var chalk_1 = __importDefault(require("chalk"));
function DEFAULT_LOGGER(_a) {
    var operationName = _a.operationName, variables = _a.variables;
    console.debug(chalk_1.default.gray("[" + operationName + "] " + JSON.stringify(variables, null, 2)));
}
exports.DEFAULT_LOGGER = DEFAULT_LOGGER;
exports.createLogLink = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.logger, logger = _c === void 0 ? DEFAULT_LOGGER : _c, _d = _b.enabled, enabled = _d === void 0 ? process.env.REACT_APP_STAGE !== 'prod' : _d;
    return new apollo_link_1.ApolloLink(function (operation, forward) {
        return forward(operation).map(function (result) {
            if (!enabled)
                return result;
            var operationName = operation.operationName, variables = operation.variables;
            logger({ operationName: operationName, variables: variables, operation: operation });
            return result;
        });
    });
};
//# sourceMappingURL=createLogLink.js.map